"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _createUseStyles = _interopRequireDefault(require("../../../themes/createUseStyles"));
var _pickAndRemoveFromObject = _interopRequireDefault(require("../../../utils/pickAndRemoveFromObject"));
var _initVars = _interopRequireDefault(require("../../../utils/vars/initVars"));
var _excluded = ["children", "className"];
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var common = ["height", "background", "zIndex"];
var vars = (0, _initVars.default)({
  applied: common
});
var TableRow = function TableRow(_ref) {
  var children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles(vars.useVars((0, _pickAndRemoveFromObject.default)(props, common)));
  return /*#__PURE__*/_react.default.createElement("tr", _extends({
    className: (0, _classnames.default)(classes.variables, classes.root, className)
  }, props), children);
};
var styles = {
  variables: vars.styles,
  root: {
    position: "relative"
  }
};
var useStyles = (0, _createUseStyles.default)(styles, {
  name: "TableRow"
});
TableRow.displayName = "TableRow";
var _default = exports.default = TableRow;